import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn.ts';
import { Icon } from '../../components/common/Icon.tsx';

const NativeButton = 'button';

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'purple' | 'teal' | 'indigo' | 'outline';

const badgeVariants = cva(
    'inline-flex items-center rounded-full border font-medium',
    {
        variants: {
            variant: {
                primary: 'border-primary/20 bg-primary text-primary-content',
                secondary: 'border-gray-200 bg-gray-100 text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300',
                success: 'border-green-200 bg-green-100 text-green-700 dark:border-green-800 dark:bg-green-900/30 dark:text-green-300',
                warning: 'border-yellow-200 bg-yellow-100 text-yellow-700 dark:border-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
                danger: 'border-red-200 bg-red-100 text-red-700 dark:border-red-800 dark:bg-red-900/30 dark:text-red-300',
                purple: 'border-purple-200 bg-purple-100 text-purple-700 dark:border-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
                teal: 'border-teal-200 bg-teal-100 text-teal-700 dark:border-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
                indigo: 'border-indigo-200 bg-indigo-100 text-indigo-700 dark:border-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300',
                outline: 'border-gray-300 bg-transparent text-gray-600 dark:border-gray-600 dark:text-gray-400',
            },
            size: {
                sm: 'px-1.5 py-0.5 text-[10px]',
                md: 'px-2.5 py-0.5 text-xs',
            },
        },
        defaultVariants: {
            variant: 'secondary',
            size: 'md',
        },
    }
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLSpanElement>,
        VariantProps<typeof badgeVariants> {
    children: React.ReactNode;
    onRemove?: () => void;
}

export const Badge: React.FC<BadgeProps> = ({ 
    children, 
    variant,
    size,
    className,
    onRemove,
    ...props
}) => (
        <span 
            className={cn(badgeVariants({ variant, size }), className)}
            {...props}
        >
            {children}
            {onRemove ? <NativeButton
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="focus-ring ml-1.5 rounded-full p-0.5 hover:opacity-75"
                    aria-label="Remove"
                >
                    <Icon name="close" size="xs" className="block md:text-[12px]" />
                </NativeButton> : null}
        </span>
    );














